import { FC } from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { GameCard } from './games/common/GameCard';
import { useGamesData } from './games/common/useGamesData';
import useUser from '@/hooks/useUser';

interface GamesSectionProps {
  difficulty?: 'basic' | 'intermediate' | 'advanced';
}

export const GamesSection: FC<GamesSectionProps> = ({ difficulty = 'basic' }) => {
  const { user } = useUser();
  const { games, userProfile, isLoading } = useGamesData(difficulty);

  if (isLoading) {
    return (
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {[1, 2, 3].map((i) => (
          <Card key={i} className="animate-pulse">
            <CardContent className="p-6">
              <div className="h-32 bg-gray-200 rounded"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-end items-center">
        <div className="text-sm text-gray-600">
          Cerebrix: {userProfile?.cerebrix || 0}
        </div>
      </div>

      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
        {games.map((game) => (
          <GameCard
            key={game.id}
            game={game}
            userSubscription={userProfile?.subscription_type}
          />
        ))}
      </div>
    </div>
  );
};